import * as React from "react";

type Props = {
  control: (show: () => void) => React.ReactNode;
  modal: (isShown: boolean, hide: () => void) => React.ReactNode;
  component: React.ElementType;
};

type State = {
  shown: boolean;
};

export default class Trigger extends React.Component<Props, State> {
  static defaultProps = { component: "div" };

  state = { shown: false };

  handleShow = () => {
    this.setState({ shown: true });
  };

  handleHide = () => {
    this.setState({ shown: false });
  };

  render() {
    const control = this.props.control(this.handleShow);
    const modal = this.props.modal(this.state.shown, this.handleHide);
    const Component = this.props.component;
    return (
      <Component>
        {control}
        {modal}
      </Component>
    );
  }
}
